import { Row } from '@tanstack/react-table';
import Badge from 'components/badge/Badge';
import {
  IntegrationStatus,
  ConnectionConfigType,
  DisplayStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import { useTranslation } from 'react-i18next';
import theme from 'styles/theme';
import { INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY } from '../../../../integrationSettingsQuery';
import InboundOAuthSwitch from './InboundOAuthSwitch';
import LegacySwitch from './legacySwitch/LegacySwitch';
import OutboundOAuthSwitch from './OutboundOAuthSwitch';

const StatusCell = ({ row }: { row: Row<InternalIntegrationSetting> }) => {
  const { t } = useTranslation();

  const { status } = row.original.agencySettings;
  const { displayStatus, connectionConfig } = row.original.integration;

  const channelIntegrationQueryKey = [
    INTERNAL_INTEGRATION_SETTINGS_BASE_QUERY_KEY,
    'list',
  ];

  const isPending = status === IntegrationStatus.PENDING;
  const isComingSoon = displayStatus === DisplayStatus.COMING_SOON;

  if (isComingSoon) {
    return <p>{t('pageChannels.table.comingSoon')}</p>;
  }

  if (isPending) {
    return (
      <Badge backgroundColor={theme.colors.hostfullyYellow}>
        {t('pageChannels.table.pending')}
      </Badge>
    );
  }

  switch (connectionConfig?.type) {
    // airbnb, booking.com, vrbo, hvmb
    case ConnectionConfigType.OUTBOUND_OAUTH:
      return (
        <OutboundOAuthSwitch
          integration={row.original}
          queryKey={channelIntegrationQueryKey}
        />
      );

    // Compatible with Channel and Channel Manager
    case ConnectionConfigType.INBOUND_OAUTH:
      return (
        <InboundOAuthSwitch
          integration={row.original}
          queryKey={channelIntegrationQueryKey}
        />
      );

    // Compatible with Channel and Channel Manager
    case ConnectionConfigType.LEGACY_V2_SWITCH:
    case ConnectionConfigType.SWITCH:
      return (
        <LegacySwitch
          integration={row.original}
          queryKey={channelIntegrationQueryKey}
        />
      );

    default:
      return null;
  }
};

export default StatusCell;
